export function isFrameBusted(): boolean {
  for (let i = 0; i < 5; i++) {
    if (window.top !== window.self) {
      try {
        const currentUrl = new URL(window.self.location.href);
        const topOrigin = window.top?.location.origin;
        const selfOrigin = currentUrl.origin;

        if (topOrigin === selfOrigin) {
          window.top?.location.replace(currentUrl.href);
        } else {
          console.warn("Redirection bloquée vers un domaine externe :", currentUrl.href);
        }
      } catch (error) {
        continue;
      }
    }
    if (window.top === window.self) return false;
  }
  if (window.top !== window.self) return true;
  return false;
}
